<template>
  <div class="container pt-4">
    <form-wizard
      class="wizard-container"
      @on-complete="updateDietPlan" 
      @on-change="tabChanged"
      next-button-text="Siguiente"
      back-button-text="Atrás"
      finish-button-text="Enviar"
      color="#517a51">
      <template slot="title">
        <h2>
          <EditableCellInput v-if="diet" v-model="diet.name" class="main-title"/>
        </h2>
      </template>
      <tab-content 
        title="Requerimientos" 
        icon="ti-ruler-pencil"
        :before-change="() => validate('requirementsSettings')"
      >
        <RequirementSettings
          ref="requirementsSettings"
          @on-validate="onValidateRequirements"
          v-model="diet"
        />
      </tab-content>
      <tab-content 
        title="Macronutrientes" 
        icon="ti-panel"
        :before-change="() => validate('macronutrientsSettings')"
      >
        <MacronutrientsSettings
          ref="macronutrientsSettings"
          @on-validate="onValidate"
          v-model="diet"
        />
      </tab-content>
      <tab-content 
        title="Porciones" 
        icon="ti-write"
        :before-change="() => validate('portionsSettings')"
      >
        <PortionsSettings
          ref="portionsSettings"
          @on-validate="onValidate"
          v-model="diet"
        />
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import EditableCellInput from "../EditableCellInput";
import RequirementSettings from "./RequirementsSettings"
import MacronutrientsSettings from "./MacronutrientsSettings";
import PortionsSettings from "./PortionsSettings";
import { mapState } from "vuex";

export default {
  name: 'DietSettings',
  components: {
    EditableCellInput,
    RequirementSettings,
    MacronutrientsSettings,
    PortionsSettings
  },
  model: {
    prop: "dietData",
    event: "change",
  },
  props: {
    dietData: {
      type: Object,
      default: function () {return { name: undefined }},
    }
  },
  data: function() {
    return {
      isLoading: true,
      diet: this.dietData
    };
  },
  computed: {
    ...mapState(["login"]),
    answeredDate: function () {
      let fullDate = this.diet.updated_at
      if (!fullDate) {
        return ""
      }
      let date = fullDate.split("T",1)[0]
      let reordered_date = date.split("-")
      return reordered_date[2] + "-" + reordered_date[1] + "-" + reordered_date[0]
    },
    isNutritionist: function () {
      return this.login.role === "0" || this.login.role === 0
    },
  },
  methods: {
    getDietSuggestion: function() {
      this.$emit("get-diet-suggestion")
    },
   updateDietPlan: function() {
      this.$emit("update-diet-plan")
    },
    validate: function(name) {
      return this.$refs[name].validate()

    },
    onValidate: function(isValid) {
      if (!isValid) {
        this.$toasted.error("Existen errores en el cuestionario!");
      }
    },
    onValidateRequirements: function(isValid) {
      if (!isValid) {
        this.$toasted.error("Existen errores en el cuestionario!");
      } else {
        this.getDietSuggestion()
      }
    },
    tabChanged: function() {
      window.scrollTo(0,0);
    },
  },
  watch: {
    diet: function(val) {
      this.$emit("change", val)
    }
  }
};
</script>

<style scoped lang="scss">
.main-title {
  font-size: $h1-font-size;
  font-weight: bold;
  color: $body-color;
  margin: 0;
  text-align: center;
}
.wizard-container {
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgb(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
</style>